import { render, staticRenderFns } from "./businessCustomerAdd.vue?vue&type=template&id=1d1a4f33&scoped=true"
import script from "./businessCustomerAdd.vue?vue&type=script&lang=js"
export * from "./businessCustomerAdd.vue?vue&type=script&lang=js"
import style0 from "./businessCustomerAdd.vue?vue&type=style&index=0&id=1d1a4f33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a4f33",
  null
  
)

export default component.exports